export const GET_BANNERS_STATED = "GET_BANNERS_STATED";
export const GET_BANNERS = "GET_BANNERS";
export const GET_BANNERS_ENDED = "GET_BANNERS_ENDED";
export const ADD_BANNER_STATED = "ADD_BANNER_STARTED";
export const ADD_BANNER = "ADD_BANNER";
export const ADD_BANNER_ENDED = "ADD_BANNER_ENDED";
export const EDIT_BANNER_STATED = "EDIT_BANNER_STATED";
export const EDIT_BANNER = "EDIT_BANNER";
export const EDIT_BANNER_ENDED = "EDIT_BANNER_ENDED";
export const GET_BANNER = "GET_BANNER";
export const GET_BANNER_STATED = "GET_BANNER_STATED";
export const GET_BANNER_ENDED = "GET_BANNER_ENDED";
export const RESET_BANNER = "RESET_BANNER";
export const ERROR_BANNER = "ERROR_BANNER";
export const GET_ALL_BANNERS_STATED = "GET_ALL_BANNERS_STATED";
export const GET_ALL_BANNERS = "GET_ALL_BANNERS";
export const GET_ALL_BANNERS_ENDED = "GET_ALL_BANNERS_ENDED";
